import React, { useState } from 'react';
import { Box, Typography, Modal, IconButton, Divider, CircularProgress, Button } from '@mui/material';
import { footerStyle, headerStyle, modalStyle } from '../OrderEntry/styles';
import { tokens } from '../../Common/designTokens';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { useNavigate } from 'react-router-dom';

const ManageFiltersModal = ({ open, onClose, filters, onDeleteFilter }) => {
  const navigate = useNavigate();
  const [deletingFilter, setDeletingFilter] = useState(null);

  const handleEdit = (filter) => {
    // Navigate to filter popup with filter data including savedFiltersId
    navigate("/search-inventory", { 
      state: {  
        isEdit: true, 
        filterName: filter.filterName,
        savedFiltersId: filter.savedFiltersId, 
        filterData: JSON.parse(filter.savedFilterJson)
      } 
    });
    onClose();
  };

  const handleDelete = async (filterName) => {
    try {
      setDeletingFilter(filterName);
      await onDeleteFilter(filterName);
    } catch (error) {
      console.error('Error deleting filter:', error);
    } finally {
      setDeletingFilter(null);
    }
  };

  return (
    <Modal open={open} onClose={onClose} aria-labelledby="manage-filters-modal-title">
      <Box sx={{
        ...modalStyle,
        width: "500px",
        maxHeight: "80vh",
      }}>
        <Box sx={headerStyle}>
          <Typography id="manage-filters-modal-title" variant="h6" fontWeight="bold" sx={{ color: tokens.colors.fontColour }}>
            Manage Saved Filters
          </Typography>
        </Box>
        <Box sx={{ 
          pt: 2, 
          pl: 3, 
          pr: 3,
          maxHeight: "calc(80vh - 170px)", // Adjusted to accommodate footer
          overflowY: "auto"
        }}>
          {filters.map((filter, index) => (
            <React.Fragment key={filter.filterName}>
              <Box sx={{ 
                display: 'flex', 
                justifyContent: 'space-between', 
                alignItems: 'center',
                py: 0.7
              }}>
                <Typography sx={{ color: tokens.colors.fontColour }}>{filter.filterName}</Typography>
                <Box>
                  <IconButton onClick={() => handleEdit(filter)} size="small" sx={{ color: tokens.colors.fontColour }}>
                    <EditIcon />
                  </IconButton>
                  <IconButton 
                    onClick={() => handleDelete(filter.filterName)} 
                    size="small" 
                    disabled={deletingFilter === filter.filterName}
                  >
                    {deletingFilter === filter.filterName ? (
                      <CircularProgress size={20} />
                    ) : (
                      <DeleteIcon />
                    )}
                  </IconButton>
                </Box>
              </Box>
              {index < filters.length - 1 && <Divider sx={{ borderColor: tokens.colors.bodyBorderColor50 }} />}
            </React.Fragment>
          ))}
        </Box>
        <Box sx={{ mt: 1, mx: 0 }}>
          <Divider sx={{ borderColor: tokens.colors.bodyBorderColor50 }} />
        </Box>
        <Box sx={{
          ...footerStyle,
          borderTop: "none",
          display : "flex",
          justifyContent:"center",
          "& > :not(style) + :not(style)": {
            ml: 2,
          },
        }}>
          <Button 
            variant="outlined" 
            onClick={onClose} 
            sx={{
                textTransform: "none", px: 4, py: 1 ,
                borderRadius:"8px",
                color: tokens.colors.fontColour,
                borderColor: tokens.colors.bodyBorderColor50
            }}
          >
            Close
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default ManageFiltersModal;
